import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../ui/Logo';
import { ReviewNote } from '../ui/ReviewNote';
import { aboutLinks, company, contact, contactReviewNotes, mainNav, QUOTE_PATH } from '../../data/site';
import { services } from '../../data/services';
const linkClass = 'text-[15px] text-steel-300 transition-colors duration-150 hover:text-white';
const headingClass = 'font-display text-[15px] font-bold uppercase tracking-[0.16em] text-white';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="border-t-4 border-brand-red bg-charcoal-950 text-steel-300" data-id="element-341" data-mp="3s0kfig6jvogz">
      <div className="mx-auto grid max-w-site gap-14 px-5 py-16 md:px-8 lg:grid-cols-12" data-id="element-342" data-mp="3n43v9x2h1u96">
        <div className="lg:col-span-4" data-id="element-343" data-mp="3j3jwkp292ikx">
          <Logo sizeClass="h-[120px]" data-id="element-344" data-mp="3e2w5y4hxo3r8" />
          <p className="mt-6 max-w-sm text-[15px] leading-relaxed" data-id="element-345" data-mp="3e1ukd63ajyv9">{company.footerDescription}</p>
          <address className="mt-8 space-y-3 text-[15px] not-italic" data-id="element-346" data-mp="394ubyoiyyk0z">
            <p data-id="element-347" data-mp="2kdcz2jub0jmg">
              <span className="block text-[12px] font-semibold uppercase tracking-[0.14em] text-steel-400" data-id="element-348" data-mp="2kcuumzxhmz3g">
                {contact.phone.label}
              </span>
              <a href={contact.phone.href} className="text-white hover:text-brand-light" data-id="element-349" data-mp="2bcev21jv8c3v">
                {contact.phone.display}
              </a>
            </p>
            <p data-id="element-350" data-mp="2gc15y4c81g9i">
              <span className="block text-[12px] font-semibold uppercase tracking-[0.14em] text-steel-400" data-id="element-351" data-mp="2g9f1idkmngvi">
                {contact.mobile.label}
              </span>
              <a href={contact.mobile.href} className="text-white hover:text-brand-light" data-id="element-352" data-mp="381e4vl03lly6">
                {contact.mobile.display}
              </a>
            </p>
            <p data-id="element-353" data-mp="2z1r491f70k66">
              <span className="block text-[12px] font-semibold uppercase tracking-[0.14em] text-steel-400" data-id="element-354" data-mp="2z17tq5rvgy26">Email</span>
              <a href={`mailto:${contact.email}`} className="text-white hover:text-brand-light" data-id="element-355" data-mp="1imzlzhbrgtal">
                {contact.email}
              </a>
            </p>
            <p data-id="element-356" data-mp="13khjxu5k6wr3">
              <span className="block text-[12px] font-semibold uppercase tracking-[0.14em] text-steel-400" data-id="element-357" data-mp="13kzgkrw4vczj">Office</span>
              {contact.physical}
              <br data-id="element-358" data-mp="zli8dqpbo1qo" />
              {contact.postal}
            </p>
          </address>
          <ReviewNote className="mt-6" data-id="element-359" data-mp="uql570eq4mlp">{contactReviewNotes.address}</ReviewNote>
        </div>

        <nav aria-label="Footer" className="grid gap-10 sm:grid-cols-3 lg:col-span-8" data-id="element-360" data-mp="pt2rkwprhj7d">
          <div data-id="element-361" data-mp="kvt4votrbln8">
            <h2 className={headingClass} data-id="element-362" data-mp="kvjazq5lcuc9">Explore</h2>
            <ul className="mt-5 space-y-3" data-id="element-363" data-mp="fuvnhegkmvms">
              {mainNav.map(item => <li key={item.label} data-id="element-364" data-mp="bt1qbg5l49rd">
                  <Link to={item.to} className={linkClass} data-id="element-365" data-mp="bu3emmbm2sr1">
                    {item.label}
                  </Link>
                </li>)}
              <li data-id="element-366" data-mp="267b0hohlzu0j">
                <Link to={QUOTE_PATH} className={linkClass} data-id="element-367" data-mp="267ulje2k2yis">
                  Request a Quote
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-368" data-mp="28s0mdcvvi8v4">
            <h2 className={headingClass} data-id="element-369" data-mp="28sisd18c81g8">About Us</h2>
            <ul className="mt-5 space-y-3" data-id="element-370" data-mp="28rqybuue2bs2">
              {aboutLinks.map(item => <li key={item.to} data-id="element-371" data-mp="2dpizzgku5c9g">
                  <Link to={item.to} className={linkClass} data-id="element-372" data-mp="2ihtxkcs3slyu">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>
          <div data-id="element-373" data-mp="2niq1urgdaa4s">
            <h2 className={headingClass} data-id="element-374" data-mp="1pt4xmh2samoo">Services</h2>
            <ul className="mt-5 space-y-3" data-id="element-375" data-mp="1pupp1xtsxpib">
              {services.map(service => <li key={service.id} data-id="element-376" data-mp="1ut10ue3nqa36">
                  <Link to={`/services#${service.id}`} className={linkClass} data-id="element-377" data-mp="1uu2m1bee0cym">
                    {service.title}
                  </Link>
                </li>)}
            </ul>
          </div>
        </nav>
      </div>

      <div className="border-t border-white/10" data-id="element-378" data-mp="3b70x9f3anhlo">
        <div className="mx-auto flex max-w-site flex-col gap-3 px-5 py-6 text-sm text-steel-400 md:flex-row md:items-center md:justify-between md:px-8" data-id="element-379" data-mp="3b68095u506gq">
          <p data-id="element-380" data-mp="3dq4apfyhz7mu">
            © {year} {company.legalName}. Company registration {company.registrationNumber}.
          </p>
          <Link to="/privacy-policy" className="transition-colors duration-150 hover:text-white" data-id="element-381" data-mp="38t4edwrg9j8x">
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>;
}